import { ContactForm } from "@/components/ContactForm";
import { InnerPageLayout } from "@/pages/InnerPageLayout";

export const ContactPage = () => (
  <InnerPageLayout testId="contact-page" eyebrow="Support" title="Contact Explordio" intro="Technical help, purchase support, and general questions for Explordio.">
    <div className="support-grid" data-testid="support-information">
      <section className="support-panel" data-testid="technical-support-section">
        <h2 data-testid="technical-support-heading">Technical support</h2>
        <p data-testid="technical-support-text">Include your platform, device model, operating-system version, Explordio version, the exact error, and steps to reproduce the issue.</p>
        <p className="support-warning" data-testid="technical-support-warning">Never send passwords, NAS/SMB/FTP credentials, payment-card details, or private file contents.</p>
      </section>
      <section className="support-panel" data-testid="purchase-support-section">
        <h2 data-testid="purchase-support-heading">Purchase support</h2>
        <p data-testid="purchase-support-text">Explordio’s one-time lifetime purchase is currently US $14.99. Restore purchases with the same Apple ID or Google account used to buy the app, where supported.</p>
        <p data-testid="purchase-support-order-text">If restoration fails, include the store, purchase date, and order or transaction reference—never full payment details.</p>
      </section>
    </div>
    <section className="contact-page-form" data-testid="contact-page-form-section">
      <ContactForm />
      <p className="direct-email" data-testid="contact-direct-email">Direct email: <a href="mailto:valbressistudios@gmail.com" data-testid="contact-email-link">valbressistudios@gmail.com</a></p>
    </section>
  </InnerPageLayout>
);